import React, { useState, useEffect } from 'react';
import InternalMenu from '../../components/shared/InternalMenu';
import ApkDropHero from '../../components/ApkDropHero';
import { StepsSection } from '../../components/home-sections';

const NewProjectView = ({ loading, isLoggedIn }) => {
  // Rotating words for banner animation
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const words = ["Analyze", "Deploy", "Optimize", "Succeed"]; // You can customize these words
  
  // Animation effect for rotating words
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 2000); // Change word every 2 seconds
    
    return () => clearInterval(interval);
  }, []);

  // Dashboard menu items with icons
  const menuItems = [
    { 
      path: '/dashboard', 
      label: 'Dashboard',
      icon: <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
        />
      </svg>
    },
    { 
      path: '/new-project', 
      label: 'New Project',
      icon: <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    },
    { 
      path: '/support', 
      label: 'Support',
      icon: <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    }
  ];

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-black">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
      </div>
    );
  }

  return (
    <div className="flex w-full min-h-screen bg-black">
      {/* Fixed Sidebar */}
      <InternalMenu 
        items={menuItems} 
        variant="dashboard" 
        showUserProfile={true} 
      />
      
      {/* Main Content Area */}
      <main className="flex-1 md:ml-64 w-full text-text-white overflow-y-auto">
        {/* Header Border Line */}
        <div className="w-full h-[1px] bg-[#e9ecef]/10"></div>

        {/* Title and description */}
        <div className="text-center mt-8 mb-4">
          <h1 className="text-3xl font-bold text-white mb-2">Let's rocket you to your first 1089 users</h1>
          <p className="text-gray-400">Join our early pioneers and launch your app to success</p>
        </div>
        
        {/* Content Area - Apk Drop Hero */}
        <div className="px-4 md:px-8 pb-6">
          <ApkDropHero hideInstructions={true} />
        </div>
        
        {/* Process Steps Section */}
        <StepsSection activeStep={1} />
      </main>
    </div>
  );
};

export default NewProjectView; 